<template>
  <div class="home" id="quotaReviewList">
    <div style="text-align: left" >
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="公司名称:">
          <el-select v-model="queryForm.tenant" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in this.tenants"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名：">
            <el-input v-model="queryForm.name" placeholder="请输入查询" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="身份证：">
            <el-input v-model="queryForm.idno" placeholder="请输入查询" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input v-model="queryForm.mobile" placeholder="请输入查询" :clearable="true"></el-input>
          </el-form-item>
        <el-form-item label="时间周期:">
        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
                v-model="queryForm.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00','23:59:59']">
          </el-date-picker>
          </el-form-item>
          <el-form-item class="search">
            <el-button type="primary" @click="loadTable" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="onReset" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
        </el-form>
    </div>
    <div style="text-align: left;margin-bottom: 20px;">
      <el-button type="primary" icon="el-icon-download" @click="exportTableSuccess">导出</el-button>
    </div>
    <!-- <div class="sys-info">
      <div class="info-a">系统发薪总人数: <span class="info-jc">{{PayrollInfo.total_Salary_Number}}</span>人</div>
      <div class="info-b">系统发薪总金额: <span class="info-jc">{{PayrollInfo.total_Salary}}</span>元</div>
    </div> -->
    <div>
      <el-table
        :data="tableData"
        :header-cell-style="tableHeader"
        border
      >
        <el-table-column prop="sss" label="序号" width="50" align="center">
          <template slot-scope="scope">
            <span>
              {{
              scope.$index + 1 + (queryForm.pageNo - 1) * queryForm.pageSize
              }}
            </span> 
          </template>
        </el-table-column>
        
        <el-table-column prop="tenantId" label="公司名称" width="150px" :show-overflow-tooltip="true" align="center" />
        <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" align="center" />
        <el-table-column prop="idno" label="身份证号码" align="center" width="200px" :show-overflow-tooltip="true" />
        <el-table-column prop="mobile" label="手机号码" align="center" width="150px" :show-overflow-tooltip="true" />
        <el-table-column prop="cardNumber" label="薪资卡号" align="center" width="200px" :show-overflow-tooltip="true" />
        <el-table-column prop="province" label="开户省份" align="center" :show-overflow-tooltip="true" />
        <el-table-column prop="bankDeposit" label="开户行" align="center" width="150px" :show-overflow-tooltip="true" />
        <el-table-column prop="subbranch" label="开户支行" align="center" width="150px" :show-overflow-tooltip="true" />
        
        <el-table-column label="本月实发工资" ><template slot-scope="scope">{{accDiv(scope.row.netSalary,100)}}</template></el-table-column> 

        <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" width="200px" align="center" />
        <el-table-column label="操作" width="100px" >
          <!-- <template slot-scope="scope">
            
            <el-button @click="noDetails(scope.row)" type="text" size="small">银行回单</el-button> 
          </template> -->
        </el-table-column>
      </el-table>
      <!-- 分页栏 -->
      <el-pagination
        id="page"
        background
        align="right"
        @size-change="handleSizeChange"
        @current-change="salarysizeChange"
        :page-sizes="[10,20,30]"
        :page-size="queryForm.pageSize"
        :current-page="queryForm.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm:{
        name:'',
        idno:'',
        mobile:'',
        time:[],
        tenant:'',
        pageNo:1,
        pageSize:10
      },
      tenants:'',
      tableData:[],
      total:0,
      itemList:[],
      itemLists:[],
      diction: {
          code: "summaryStatus",
      },
      tenants:'',
      PayrollInfo:'',
      loading: false,
      salaryInfo:{
        buscod:'',
        yurref:'',
        bgndat:'',
        enddat:'',
        salarySummarizingId:'',
        salarySummarizingRecordsId:'',
        zhtenantID:'',
        createTime:'',
      },
      
    };
  },
  async created() {
    this.loadTable();
    
  },
  // 挂载查询方法
  mounted() {
    // this.findDictionariesItemList(this.diction);
    // this.findDictionariesItemLists(this.dictions);
  },
  methods: {
        //查询客户信息
    async listTenantInfos() {
      this.tableLoading = true;
      await this.api.salaryApi.finTenants(this.queryForm).then(res => {
        console.log("-----",res)
          this.tenants = res.data;
        });
    },
   
    // 查询
    async loadTable() {
      this.tableLoading = true;
      await this.api.salaryApi.payrollListData(this.queryForm).then(res => {
          res = res.data;
          if(res.code == 200){
            this.tableData = res.data.records;
            this.total = res.data.total;
          }else{
            this.tableData =  null;
            this.total = 0;
            this.$message.error(res.msg);
          }
        });
        // this.listPayrollInfos();
        // this.listTenantInfos()
        this.listTenantInfos();
    },

    async exportTableSuccess(){
        console.log("导出下载");
        await this.api.salaryApi.downloadstaffRecordInfo(this.queryForm).then(res =>{
          console.log(res)
          let fileNameEncode = "员工收入记录.xlsx";
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel"});
          console.log(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download",  decodeURIComponent(fileNameEncode));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
      },
    
  
    // async findDictionariesItemList(param) {
    //   let response = await this.api.platformApi.findDictionariesItemList(param);
    //   console.log("数据字典", response);
    //   this.itemList = response.data.data;
    // },
    // 分页改变时触发
    salarysizeChange(page) {
      this.queryForm.pageNo = page;
      this.loadTable();
    },
    handleSizeChange(size) {
      this.queryForm.pageSize = size;
      this.loadTable();
    },
    // 重置
    onReset() {
      this.queryForm.tenant=null;
      this.queryForm.time=[],
      this.queryForm.name='';
      this.queryForm.idno='';
      this.queryForm.mobile='';
      this.loadTable();
    },
    // 查看函数
    noDetails(row){
        this.$router.push({path: '/payrollLogDetails',query: {salarySummarizingRecordsId: row.id,createTime:row.createTime}})
    },
    // 导出
    derive() {},
    // async findDictionariesItemLists(param) {
    //   let response = await this.api.platformApi.findDictionariesItemList(param);
    //   console.log("数据字典", response);
    //   this.itemLists = response.data.data;
    // },
    tableHeader(column) {
      return "height:36px;background-color:#fafafa;color:#333333;padding:0";
    },
    afi(fmt){
      // Date.prototype.format = function(fmt) { 
          var o = { 
              "M+" : this.getMonth()+1,                 //月份 
              "d+" : this.getDate(),                    //日 
              "h+" : this.getHours(),                   //小时 
              "m+" : this.getMinutes(),                 //分 
              "s+" : this.getSeconds(),                 //秒 
              "q+" : Math.floor((this.getMonth()+3)/3), //季度 
              "S"  : this.getMilliseconds()             //毫秒 
          }; 
          if(/(y+)/.test(fmt)) {
                  fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
          }
          for(var k in o) {
              if(new RegExp("("+ k +")").test(fmt)){
                  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
              }
          }
          return fmt; 
      // }       
    },
    //除法函数
    accDiv(arg1, arg2){
         if(arg1!=null){
          var t1 = 0, t2 = 0, r1, r2;
          try {
            t1 = arg1.toString().split(".")[1].length;
          }
          catch (e) {
          }
          try {
            t2 = arg2.toString().split(".")[1].length;
          }
          catch (e) {
          }
          r1 = Number(arg1.toString().replace(".", ""));
          r2 = Number(arg2.toString().replace(".", ""));
          return (r1 / r2) * Math.pow(10, t2 - t1);
         }
         else{
          return null
         }
        }
  }
};
</script>

<style scoped>
#quotaReviewList {
  overflow: hidden;
  background-color: white;
  padding: 15px 20px 100px;
}
.sys-info{
  display: flex;
  font-size: 20px;
  margin-bottom: 10px;
  background: #00FFFF;
  border-radius: 10px;
}
.info-a{
  margin: 0 100px 0 10px;
}
.info-b{

}
.info-jc{
  color: red;
  font-weight: 900;
  font-size: 24px;
}
.search{
  margin-left: 50px;
}
</style>
